/**
 * Sidebar in the locked order (ADR 0016 rule 6; locked decision 5 naming; decision O10):
 * Dashboard, Requests, Projects, Production, Reviews; Create: Image Studio, Video Studio,
 * Shooting, Editor; Intelligence: Assets, Talents, Products, Karya, Product Brain.
 * Items outside M1 stay visible and open an honest state page. Labels are i18n keys.
 */
import {
  BadgeCheck,
  Boxes,
  Brain,
  Camera,
  Clapperboard,
  FileText,
  Folder,
  FolderOpen,
  Image,
  LayoutDashboard,
  Package,
  ScissorsLineDashed,
  Sparkles,
  Users,
  Video,
  type LucideIcon,
} from "lucide-react";

export type HonestKind = "workflow" | "ai_production_phase";

export type NavItem = {
  key: string; // nav.<key> label, honest.<key> description
  path: string;
  icon: LucideIcon;
  honest: HonestKind; // what the page honestly shows until its screen is built
  live?: boolean; // the real screen exists (no honest-state page)
};

export type NavGroup = { labelKey: string | null; items: NavItem[] };

export const NAVIGATION: NavGroup[] = [
  {
    labelKey: null,
    items: [
      { key: "dashboard", path: "/", icon: LayoutDashboard, honest: "workflow", live: true },
      { key: "requests", path: "/requests", icon: FileText, honest: "workflow", live: true },
      { key: "projects", path: "/projects", icon: Folder, honest: "workflow", live: true },
      { key: "production", path: "/production", icon: Clapperboard, honest: "workflow", live: true },
      { key: "reviews", path: "/reviews", icon: BadgeCheck, honest: "workflow", live: true },
    ],
  },
  {
    labelKey: "nav.group_create",
    items: [
      { key: "image_studio", path: "/studio/image", icon: Image, honest: "ai_production_phase", live: true },
      { key: "video_studio", path: "/studio/video", icon: Video, honest: "ai_production_phase", live: true },
      { key: "shooting", path: "/shooting", icon: Camera, honest: "workflow", live: true },
      { key: "editor", path: "/editor", icon: ScissorsLineDashed, honest: "workflow", live: true },
    ],
  },
  {
    labelKey: "nav.group_intelligence",
    items: [
      { key: "assets", path: "/assets", icon: FolderOpen, honest: "workflow", live: true },
      { key: "talents", path: "/talents", icon: Users, honest: "workflow" },
      { key: "products", path: "/products", icon: Package, honest: "workflow", live: true },
      { key: "karya", path: "/karya", icon: Sparkles, honest: "workflow", live: true },
      { key: "product_brain", path: "/product-brain", icon: Brain, honest: "workflow" },
    ],
  },
];

export const ALL_NAV_ITEMS: NavItem[] = NAVIGATION.flatMap((g) => g.items);
export const ADMIN_ITEM: NavItem = { key: "admin", path: "/admin", icon: Boxes, honest: "workflow" };
